module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eiBYD"))).then(() => module.bundle.root('f4eak'));